import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-csr-range',
  templateUrl: './csr-range.component.html',
  styleUrls: [],
  standalone: false
})
export class CsRefundRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
